export const EVENT_CHANGE = "change";
export const ACTIVATOR_SLOT = "activator";
export const ORGANIZATION_COLLAPSE_CLICK = "click";
